import React from 'react';
import { useLocation } from 'react-router-dom';
import './DailyVerse.css';
import fetchDailyVerse from '../../data/fetchs/fetchDailyVerse';
import ShareIcon from '@mui/icons-material/Share';

import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

import PlayerFloating from '../PlayerFloating/PlayerFloating';
import FloatingPlayer from '../FloatingPlayer/FloatingPlayer';

const DailyVerse = () => {
    const [verse, setVerse] = React.useState(null);
    const location = useLocation(); // Nuevo

    React.useEffect(() => {
        // Se remueve el flag de validación para evitar cacheo
        // Se añade un parámetro de caché para forzar la petición con datos frescos
        fetchDailyVerse(`?t=${Date.now()}`)
            .then(verse => {
              setVerse(verse)
            })
            .catch(error => console.error(error));
    // Dependencia vacía para ejecutar solo al montar el componente
    }, []); 

    const handleShare = async () => {
        if (navigator.share) {
          try {
            await navigator.share({
              title: title || document.title, // Use provided title or document title
              text: text || 'Check out this image!', // Use provided text or default
              url: verse.featuredImage, // Use provided URL or current page URL
            });
            console.log('Successful share');
          } catch (error) {
            console.error('Error sharing', error);
          }
        } else {
          alert('Web Share API is not supported in this browser. Image URL: ' + verse.featuredImage);
        }
      };

    return (
        <div className="privacy-container">
          {/* <FloatingPlayer /> */}
            { !verse ? (
                <Stack spacing={1}>
                  <Skeleton variant="rounded" height={40} />
                  <Skeleton variant="rounded" width="100%" height={300} />
                  <Skeleton variant="text" height={120} />
                </Stack>
            ) : (
                <>
                    <h1 style={{ textAlign: 'center' }}>Versiculo del día</h1>
                    {verse.featuredImage && (
                        <div style={{ position: 'relative', textAlign: 'center' }}>
                            <img src={verse.featuredImage} alt="Featured" style={{ maxWidth: '500px', height: 'auto', display: 'block', margin: '0 auto' }} />
                            {/* <ShareIcon className="share-icon" onClick={handleShare} /> */}
                        </div>
                    )}
                    <h2>{verse.title}</h2>
                    <div dangerouslySetInnerHTML={{ __html: verse.content }}></div>
                </>
            )}
        </div>
    );
};

export default DailyVerse;
